// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./custom.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./block-types-list.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./inserter.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./inspector.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./node-types.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./dev.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./guide.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./toolbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./notices.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./pro-features.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./conditionals.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reactflow-wrapper {
    height: 100%;
}

.components-notice {
    padding: 0 12px;
}

.components-notice-list .components-notice__dismiss {
    margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-editor/css/index.css"],"names":[],"mappings":"AAYA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["@import url('custom.css');\n@import url('block-types-list.css');\n@import url('inserter.css');\n@import url('inspector.css');\n@import url('node-types.css');\n@import url('dev.css');\n@import url('guide.css');\n@import url('toolbar.css');\n@import url('notices.css');\n@import url('pro-features.css');\n@import url('conditionals.css');\n\n.reactflow-wrapper {\n    height: 100%;\n}\n\n.components-notice {\n    padding: 0 12px;\n}\n\n.components-notice-list .components-notice__dismiss {\n    margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
